export default __webpack_public_path__ + "static/media/frank pallone.23cb3b11.jpg";